export type BaseScriptType = {
    src: string
    id: string
}
export type CookieBotBannerType = {
    dataCbid?: string
    dataBlockingmode?: string
    type?: string
    async?: boolean
}

/*
--------------------
  COOKIE MANAGERS
--------------------
*/
export enum CookieManagersEnum {
    COOKIE_BOT = "cookiebot"
}

/* ---------- COOKIE BOT ---------- */


export type CookieInizializationScript = BaseScriptType & CookieBotBannerType

export type CookieBotType = {
    enabled: boolean
    initializationScript: [CookieInizializationScript],
}

export type CookieManagersType = {
    [CookieManagersEnum.COOKIE_BOT]: CookieBotType
}

/*
--------------
  ANALYTICS
--------------
*/
export enum AnalyticsEnum {
    GOOGLE = 'google',
    FACEBOOK = 'facebook',
    MATOMO = 'matomo',
    GA = 'ga',
    GTM = 'gtm',
}

export enum AnalyticsEventsEnum {
    LOGIN = "login",
    INVITATION_CODE = "invitationCode",
    REGISTRATION_FORM = "registrationForm",
    FORGOT_PASSWORD_FORM = "forgotPasswordForm",
    RESET_PASSWORD_FORM = "resetPasswordForm",
    SSO_FINALIZATION_FORM = "ssoFinalizationForm",
    WEB_FINALIZATION_FORM = "webFinalizationForm",
    PROFILE_MODIFICATION_FORM = "profileModificationForm",
    AVATAR_MODIFICATION_FORM = "avatarModificationForm",
    CONTACT_FORM = "contactForm",
    PLAY_CONTEST_CTA = "playContestCta",
    EVENTS_FORM = "eventsForm",
    REDEMPTION_FORM = "redemptionForm",
    ADD_TO_CART_CTA = "addToCartCta",
    REDEEM_REWARD_CTA = "redeemRewardCta",
    PAGE_VIEW = "pageView"
}

export enum AnalyticsActionsEnum {
    FORM = "form",
    CTA = "cta"
}

export type MatomoTracking = GenericAnalyticsEvent & {
    type: string,
}

export type GenericAnalyticsEvent = {
    category?: string
    action?: string
    name?: string
    value?: string
}

export type AnalyticsEventsMap = GenericAnalyticsEvent & {
    event: AnalyticsEventsEnum
    enabled: boolean
}

export type MatomoInizializationScript = BaseScriptType & {
    url?: string
    siteId?: string
}

export type AnalyticsType = {
    [AnalyticsEnum.MATOMO]: {
        enabled: boolean
        initializationScript: [MatomoInizializationScript],
        eventTracking: AnalyticsEventsMap[]
    }
}

export type CustomAnalyticEventPayload = Array<{analyticType: AnalyticsEnum, [key:string]: string}>